import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { TranslationCultureResponse } from "@/main/models/response/translationCultureResponse";
import { TranslateCultureRequest } from "@/main/models/request";

export abstract class ITranslateApi {
	abstract getTranslates(filter: TranslateCultureRequest): Promise<AxiosResponse<Result<TranslationCultureResponse>>>;
}
